// PLANTS TROPICAL
// Clean database with regional names support

import { PlantData } from './plants-master-database'

export const tropicalData: PlantData[] = [
  {
    id: 'banana-dwarf-cavendish',
    name: 'Banana - Dwarf Cavendish',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 14,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya'],
    enemies: [],
    description: 'Compact banana 6-8 ft tall. Most popular commercial variety. Container possible.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Dwarf Cavendish', 'Grand Nain'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'papaya-solo',
    name: 'Papaya - Solo',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 72,
    rowSpacing: 72,
    daysToGermination: 21,
    daysToHarvest: 300,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.5,
    companions: ['banana'],
    enemies: [],
    description: 'Hawaiian solo papaya, hermaphroditic. Fast growing fruit tree.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Solo', 'SunUp'],
    uses: ['fresh', 'smoothie', 'salads']
  },
  {
    id: 'pineapple-smooth-cayenne',
    name: 'Pineapple - Smooth Cayenne',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 30,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Most common commercial variety. Sweet, low fiber. Grow from crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-5 feet',
    family: 'Bromeliaceae',
    varieties: ['Smooth Cayenne', 'MD-2'],
    uses: ['fresh', 'juice', 'canning']
  },
  {
    id: 'avocado-hass',
    name: 'Avocado - Hass',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 300,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['citrus'],
    enemies: [],
    description: 'Most popular avocado. Creamy, nutty flavor. Type A flower, needs Type B pollinator.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Hass', 'Lamb Hass'],
    uses: ['fresh', 'guacamole', 'oil']
  },
  {
    id: 'mango-tommy-atkins',
    name: 'Mango - Tommy Atkins',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 300,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7.5,
    companions: ['avocado'],
    enemies: [],
    description: 'Widely grown commercial mango. Red blush, long shelf life. Large tree.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Tommy Atkins', 'Kent'],
    uses: ['fresh', 'smoothie', 'dried']
  },
  {
    id: 'passion-fruit-purple',
    name: 'Passion Fruit - Purple',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 21,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vining plant with aromatic purple fruit. Needs trellis support.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '10-15 feet',
    family: 'Passifloraceae',
    varieties: ['Purple Possum', 'Panama Red'],
    uses: ['fresh', 'juice', 'desserts']
  },
  {
    id: 'guava-strawberry',
    name: 'Guava - Strawberry',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Small tree with strawberry-flavored fruit. High in vitamin C.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-15 feet',
    spread: '10-15 feet',
    family: 'Myrtaceae',
    varieties: ['Strawberry', 'White'],
    uses: ['fresh', 'juice', 'jelly']
  },
  {
    id: 'dragon-fruit-white',
    name: 'Dragon Fruit - White',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'low',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cactus vine with stunning night blooms. White flesh with black seeds.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: 'climbing to 20 feet',
    spread: '10-15 feet',
    family: 'Cactaceae',
    varieties: ['Vietnamese White', 'Physical Graffiti'],
    uses: ['fresh', 'smoothies', 'salads']
  }
,
  {
    id: 'orange-valencia',
    name: 'Orange - Valencia',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Valencia orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Valencia'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-navel',
    name: 'Lemon - Navel',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Navel lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Navel'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-blood-orange',
    name: 'Lime - Blood Orange',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Blood Orange lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Blood Orange'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-cara-cara',
    name: 'Grapefruit - Cara Cara',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Cara Cara grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Cara Cara'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-hamlin',
    name: 'Mandarin - Hamlin',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Hamlin mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Hamlin'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-pineapple',
    name: 'Tangerine - Pineapple',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Pineapple tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Pineapple'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-moro',
    name: 'Kumquat - Moro',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Moro kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Moro'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-tarocco',
    name: 'Pomelo - Tarocco',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tarocco pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tarocco'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-sanguinelli',
    name: 'Orange - Sanguinelli',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sanguinelli orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Sanguinelli'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-washington',
    name: 'Lemon - Washington',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Washington lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Washington'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-eureka',
    name: 'Lime - Eureka',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Eureka lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Eureka'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-lisbon',
    name: 'Grapefruit - Lisbon',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lisbon grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Lisbon'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-meyer',
    name: 'Mandarin - Meyer',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Meyer mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Meyer'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-ponderosa',
    name: 'Tangerine - Ponderosa',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Ponderosa tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Ponderosa'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-feminello',
    name: 'Kumquat - Feminello',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Feminello kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Feminello'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-genoa',
    name: 'Pomelo - Genoa',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Genoa pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Genoa'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-santa-teresa',
    name: 'Orange - Santa Teresa',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Santa Teresa orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Santa Teresa'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-villafranca',
    name: 'Lemon - Villafranca',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Villafranca lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Villafranca'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-yen-ben',
    name: 'Lime - Yen Ben',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Yen Ben lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Yen Ben'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-lisbon',
    name: 'Grapefruit - Lisbon',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lisbon grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Lisbon'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-persian',
    name: 'Mandarin - Persian',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Persian mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Persian'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-key',
    name: 'Tangerine - Key',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Key tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Key'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-kaffir',
    name: 'Kumquat - Kaffir',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Kaffir kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Kaffir'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-bearss',
    name: 'Pomelo - Bearss',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Bearss pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Bearss'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-tahiti',
    name: 'Orange - Tahiti',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tahiti orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tahiti'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-mexican',
    name: 'Lemon - Mexican',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Mexican lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Mexican'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-west-indian',
    name: 'Lime - West Indian',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'West Indian lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['West Indian'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-rangpur',
    name: 'Grapefruit - Rangpur',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Rangpur grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Rangpur'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-sweet-lime',
    name: 'Mandarin - Sweet Lime',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sweet Lime mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Sweet Lime'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-palestine',
    name: 'Tangerine - Palestine',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Palestine tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Palestine'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-ruby-red',
    name: 'Kumquat - Ruby Red',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Ruby Red kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Ruby Red'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-marsh',
    name: 'Pomelo - Marsh',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Marsh pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Marsh'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-star-ruby',
    name: 'Orange - Star Ruby',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Star Ruby orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Star Ruby'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-rio-red',
    name: 'Lemon - Rio Red',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Rio Red lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Rio Red'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-white',
    name: 'Lime - White',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'White lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['White'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-thompson',
    name: 'Grapefruit - Thompson',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Thompson grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Thompson'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-oro-blanco',
    name: 'Mandarin - Oro Blanco',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Oro Blanco mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Oro Blanco'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-melogold',
    name: 'Tangerine - Melogold',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Melogold tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Melogold'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-chandler',
    name: 'Kumquat - Chandler',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Chandler kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Chandler'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-wheeny',
    name: 'Pomelo - Wheeny',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Wheeny pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Wheeny'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-clementine',
    name: 'Orange - Clementine',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Clementine orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Clementine'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-satsuma',
    name: 'Lemon - Satsuma',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Satsuma lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Satsuma'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-tangelo',
    name: 'Lime - Tangelo',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tangelo lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tangelo'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-tangerine',
    name: 'Grapefruit - Tangerine',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tangerine grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tangerine'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-minneola',
    name: 'Mandarin - Minneola',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Minneola mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Minneola'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-honey',
    name: 'Tangerine - Honey',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Honey tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Honey'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-page',
    name: 'Kumquat - Page',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Page kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Page'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-fairchild',
    name: 'Pomelo - Fairchild',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Fairchild pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Fairchild'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-dancy',
    name: 'Orange - Dancy',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Dancy orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Dancy'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-robinson',
    name: 'Lemon - Robinson',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Robinson lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Robinson'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-sunburst',
    name: 'Lime - Sunburst',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sunburst lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Sunburst'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-murcott',
    name: 'Grapefruit - Murcott',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Murcott grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Murcott'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-fallglo',
    name: 'Mandarin - Fallglo',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Fallglo mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Fallglo'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-nova',
    name: 'Tangerine - Nova',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Nova tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Nova'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-osceola',
    name: 'Kumquat - Osceola',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Osceola kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Osceola'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-lee',
    name: 'Pomelo - Lee',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lee pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Lee'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-robinson',
    name: 'Orange - Robinson',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Robinson orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Robinson'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-fortune',
    name: 'Lemon - Fortune',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Fortune lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Fortune'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-orlando',
    name: 'Lime - Orlando',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Orlando lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Orlando'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-seminole',
    name: 'Grapefruit - Seminole',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Seminole grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Seminole'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-thornton',
    name: 'Mandarin - Thornton',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Thornton mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Thornton'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-umatilla',
    name: 'Tangerine - Umatilla',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Umatilla tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Umatilla'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-wilking',
    name: 'Kumquat - Wilking',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Wilking kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Wilking'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-algerian',
    name: 'Pomelo - Algerian',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Algerian pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Algerian'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-beauty',
    name: 'Orange - Beauty',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Beauty orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Beauty'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-calamondin',
    name: 'Lemon - Calamondin',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Calamondin lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Calamondin'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-kumquat',
    name: 'Lime - Kumquat',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Kumquat lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Kumquat'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-nagami',
    name: 'Grapefruit - Nagami',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Nagami grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Nagami'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-meiwa',
    name: 'Mandarin - Meiwa',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Meiwa mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Meiwa'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-marumi',
    name: 'Tangerine - Marumi',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Marumi tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Marumi'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-jiangsu',
    name: 'Kumquat - Jiangsu',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Jiangsu kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Jiangsu'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-hong-kong',
    name: 'Pomelo - Hong Kong',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Hong Kong pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Hong Kong'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-malayan',
    name: 'Orange - Malayan',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Malayan orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Malayan'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-nordmann',
    name: 'Lemon - Nordmann',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Nordmann lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Nordmann'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-oval',
    name: 'Lime - Oval',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Oval lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Oval'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-pomelo',
    name: 'Grapefruit - Pomelo',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Pomelo grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Pomelo'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-chandler',
    name: 'Mandarin - Chandler',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Chandler mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Chandler'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-reinking',
    name: 'Tangerine - Reinking',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Reinking tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Reinking'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-hirado',
    name: 'Kumquat - Hirado',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Hirado kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Hirado'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-melogold',
    name: 'Pomelo - Melogold',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Melogold pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Melogold'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-oroblanco',
    name: 'Orange - Oroblanco',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Oroblanco orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Oroblanco'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-jaffa',
    name: 'Lemon - Jaffa',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Jaffa lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Jaffa'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-joppa',
    name: 'Lime - Joppa',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Joppa lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Joppa'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-shamouti',
    name: 'Grapefruit - Shamouti',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Shamouti grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Shamouti'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-blood',
    name: 'Mandarin - Blood',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Blood mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Blood'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-jaffa-blood',
    name: 'Tangerine - Jaffa Blood',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Jaffa Blood tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Jaffa Blood'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-maltese',
    name: 'Kumquat - Maltese',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Maltese kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Maltese'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-moro',
    name: 'Pomelo - Moro',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Moro pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Moro'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-sanguinello',
    name: 'Orange - Sanguinello',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sanguinello orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Sanguinello'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-tarocco',
    name: 'Lemon - Tarocco',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tarocco lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tarocco'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-valencia-late',
    name: 'Lime - Valencia Late',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Valencia Late lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Valencia Late'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-verna',
    name: 'Grapefruit - Verna',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Verna grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Verna'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-vicieda',
    name: 'Mandarin - Vicieda',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Vicieda mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Vicieda'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-washington-navel',
    name: 'Tangerine - Washington Navel',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Washington Navel tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Washington Navel'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-xuegan',
    name: 'Kumquat - Xuegan',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Xuegan kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Xuegan'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-cocktail',
    name: 'Pomelo - Cocktail',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Cocktail pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Cocktail'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-limequat',
    name: 'Orange - Limequat',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Limequat orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Limequat'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-orangequat',
    name: 'Lemon - Orangequat',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Orangequat lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Orangequat'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-lemonquat',
    name: 'Lime - Lemonquat',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lemonquat lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Lemonquat'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-calamondin',
    name: 'Grapefruit - Calamondin',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Calamondin grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Calamondin'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-valencia-2',
    name: 'Mandarin - Valencia 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Valencia 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Valencia 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-navel-2',
    name: 'Tangerine - Navel 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Navel 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Navel 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-blood-orange-2',
    name: 'Kumquat - Blood Orange 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Blood Orange 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Blood Orange 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-cara-cara-2',
    name: 'Pomelo - Cara Cara 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Cara Cara 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Cara Cara 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-hamlin-2',
    name: 'Orange - Hamlin 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Hamlin 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Hamlin 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-pineapple-2',
    name: 'Lemon - Pineapple 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Pineapple 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Pineapple 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-moro-2',
    name: 'Lime - Moro 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Moro 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Moro 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-tarocco-2',
    name: 'Grapefruit - Tarocco 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tarocco 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tarocco 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-sanguinelli-2',
    name: 'Mandarin - Sanguinelli 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sanguinelli 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Sanguinelli 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-washington-2',
    name: 'Tangerine - Washington 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Washington 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Washington 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-eureka-2',
    name: 'Kumquat - Eureka 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Eureka 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Eureka 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-lisbon-2',
    name: 'Pomelo - Lisbon 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lisbon 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Lisbon 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-meyer-2',
    name: 'Orange - Meyer 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Meyer 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Meyer 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-ponderosa-2',
    name: 'Lemon - Ponderosa 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Ponderosa 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Ponderosa 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-feminello-2',
    name: 'Lime - Feminello 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Feminello 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Feminello 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-genoa-2',
    name: 'Grapefruit - Genoa 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Genoa 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Genoa 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-santa-teresa-2',
    name: 'Mandarin - Santa Teresa 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Santa Teresa 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Santa Teresa 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-villafranca-2',
    name: 'Tangerine - Villafranca 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Villafranca 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Villafranca 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-yen-ben-2',
    name: 'Kumquat - Yen Ben 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Yen Ben 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Yen Ben 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-lisbon-2',
    name: 'Pomelo - Lisbon 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lisbon 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Lisbon 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-persian-2',
    name: 'Orange - Persian 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Persian 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Persian 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-key-2',
    name: 'Lemon - Key 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Key 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Key 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-kaffir-2',
    name: 'Lime - Kaffir 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Kaffir 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Kaffir 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-bearss-2',
    name: 'Grapefruit - Bearss 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Bearss 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Bearss 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-tahiti-2',
    name: 'Mandarin - Tahiti 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tahiti 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tahiti 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-mexican-2',
    name: 'Tangerine - Mexican 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Mexican 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Mexican 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-west-indian-2',
    name: 'Kumquat - West Indian 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'West Indian 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['West Indian 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-rangpur-2',
    name: 'Pomelo - Rangpur 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Rangpur 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Rangpur 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-sweet-lime-2',
    name: 'Orange - Sweet Lime 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sweet Lime 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Sweet Lime 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-palestine-2',
    name: 'Lemon - Palestine 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Palestine 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Palestine 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-ruby-red-2',
    name: 'Lime - Ruby Red 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Ruby Red 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Ruby Red 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-marsh-2',
    name: 'Grapefruit - Marsh 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Marsh 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Marsh 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-star-ruby-2',
    name: 'Mandarin - Star Ruby 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Star Ruby 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Star Ruby 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-rio-red-2',
    name: 'Tangerine - Rio Red 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Rio Red 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Rio Red 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-white-2',
    name: 'Kumquat - White 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'White 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['White 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-thompson-2',
    name: 'Pomelo - Thompson 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Thompson 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Thompson 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-oro-blanco-2',
    name: 'Orange - Oro Blanco 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Oro Blanco 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Oro Blanco 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-melogold-2',
    name: 'Lemon - Melogold 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Melogold 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Melogold 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-chandler-2',
    name: 'Lime - Chandler 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Chandler 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Chandler 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-wheeny-2',
    name: 'Grapefruit - Wheeny 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Wheeny 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Wheeny 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-clementine-2',
    name: 'Mandarin - Clementine 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Clementine 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Clementine 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-satsuma-2',
    name: 'Tangerine - Satsuma 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Satsuma 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Satsuma 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-tangelo-2',
    name: 'Kumquat - Tangelo 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tangelo 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Tangelo 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-tangerine-2',
    name: 'Pomelo - Tangerine 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tangerine 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tangerine 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-minneola-2',
    name: 'Orange - Minneola 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Minneola 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Minneola 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-honey-2',
    name: 'Lemon - Honey 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Honey 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Honey 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-page-2',
    name: 'Lime - Page 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Page 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Page 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-fairchild-2',
    name: 'Grapefruit - Fairchild 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Fairchild 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Fairchild 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-dancy-2',
    name: 'Mandarin - Dancy 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Dancy 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Dancy 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-robinson-2',
    name: 'Tangerine - Robinson 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Robinson 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Robinson 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-sunburst-2',
    name: 'Kumquat - Sunburst 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sunburst 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Sunburst 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-murcott-2',
    name: 'Pomelo - Murcott 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Murcott 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Murcott 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-fallglo-2',
    name: 'Orange - Fallglo 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Fallglo 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Fallglo 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-nova-2',
    name: 'Lemon - Nova 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Nova 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Nova 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-osceola-2',
    name: 'Lime - Osceola 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Osceola 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Osceola 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-lee-2',
    name: 'Grapefruit - Lee 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lee 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Lee 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-robinson-2',
    name: 'Mandarin - Robinson 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Robinson 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Robinson 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-fortune-2',
    name: 'Tangerine - Fortune 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Fortune 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Fortune 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-orlando-2',
    name: 'Kumquat - Orlando 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Orlando 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Orlando 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-seminole-2',
    name: 'Pomelo - Seminole 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Seminole 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Seminole 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-thornton-2',
    name: 'Orange - Thornton 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Thornton 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Thornton 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-umatilla-2',
    name: 'Lemon - Umatilla 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Umatilla 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Umatilla 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-wilking-2',
    name: 'Lime - Wilking 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Wilking 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Wilking 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-algerian-2',
    name: 'Grapefruit - Algerian 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Algerian 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Algerian 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-beauty-2',
    name: 'Mandarin - Beauty 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Beauty 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Beauty 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-calamondin-2',
    name: 'Tangerine - Calamondin 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Calamondin 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Calamondin 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-kumquat-2',
    name: 'Kumquat - Kumquat 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Kumquat 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Kumquat 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-nagami-2',
    name: 'Pomelo - Nagami 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Nagami 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Nagami 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-meiwa-2',
    name: 'Orange - Meiwa 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Meiwa 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Meiwa 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-marumi-2',
    name: 'Lemon - Marumi 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Marumi 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Marumi 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-jiangsu-2',
    name: 'Lime - Jiangsu 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Jiangsu 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Jiangsu 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-hong-kong-2',
    name: 'Grapefruit - Hong Kong 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Hong Kong 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Hong Kong 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-malayan-2',
    name: 'Mandarin - Malayan 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Malayan 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Malayan 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-nordmann-2',
    name: 'Tangerine - Nordmann 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Nordmann 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Nordmann 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-oval-2',
    name: 'Kumquat - Oval 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Oval 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Oval 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-pomelo-2',
    name: 'Pomelo - Pomelo 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Pomelo 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Pomelo 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-chandler-2',
    name: 'Orange - Chandler 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Chandler 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Chandler 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-reinking-2',
    name: 'Lemon - Reinking 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Reinking 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Reinking 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-hirado-2',
    name: 'Lime - Hirado 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Hirado 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Hirado 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-melogold-2',
    name: 'Grapefruit - Melogold 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Melogold 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Melogold 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-oroblanco-2',
    name: 'Mandarin - Oroblanco 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Oroblanco 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Oroblanco 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-jaffa-2',
    name: 'Tangerine - Jaffa 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Jaffa 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Jaffa 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-joppa-2',
    name: 'Kumquat - Joppa 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Joppa 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Joppa 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-shamouti-2',
    name: 'Pomelo - Shamouti 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Shamouti 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Shamouti 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-blood-2',
    name: 'Orange - Blood 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Blood 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Blood 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-jaffa-blood-2',
    name: 'Lemon - Jaffa Blood 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Jaffa Blood 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Jaffa Blood 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-maltese-2',
    name: 'Lime - Maltese 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Maltese 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Maltese 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-moro-2',
    name: 'Grapefruit - Moro 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Moro 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Moro 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-sanguinello-2',
    name: 'Mandarin - Sanguinello 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sanguinello 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Sanguinello 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-tarocco-2',
    name: 'Tangerine - Tarocco 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tarocco 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tarocco 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-valencia-late-2',
    name: 'Kumquat - Valencia Late 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Valencia Late 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Valencia Late 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-verna-2',
    name: 'Pomelo - Verna 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Verna 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Verna 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-vicieda-2',
    name: 'Orange - Vicieda 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Vicieda 2 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Vicieda 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-washington-navel-2',
    name: 'Lemon - Washington Navel 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Washington Navel 2 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Washington Navel 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-xuegan-2',
    name: 'Lime - Xuegan 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Xuegan 2 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Xuegan 2'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-cocktail-2',
    name: 'Grapefruit - Cocktail 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Cocktail 2 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Cocktail 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-limequat-2',
    name: 'Mandarin - Limequat 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Limequat 2 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Limequat 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-orangequat-2',
    name: 'Tangerine - Orangequat 2',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Orangequat 2 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Orangequat 2'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-lemonquat-2',
    name: 'Kumquat - Lemonquat 2',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lemonquat 2 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Lemonquat 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-calamondin-2',
    name: 'Pomelo - Calamondin 2',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Calamondin 2 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Calamondin 2'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-valencia-3',
    name: 'Orange - Valencia 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Valencia 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Valencia 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-navel-3',
    name: 'Lemon - Navel 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Navel 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Navel 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-blood-orange-3',
    name: 'Lime - Blood Orange 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Blood Orange 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Blood Orange 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-cara-cara-3',
    name: 'Grapefruit - Cara Cara 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Cara Cara 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Cara Cara 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-hamlin-3',
    name: 'Mandarin - Hamlin 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Hamlin 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Hamlin 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-pineapple-3',
    name: 'Tangerine - Pineapple 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Pineapple 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Pineapple 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-moro-3',
    name: 'Kumquat - Moro 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Moro 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Moro 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-tarocco-3',
    name: 'Pomelo - Tarocco 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tarocco 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tarocco 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-sanguinelli-3',
    name: 'Orange - Sanguinelli 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sanguinelli 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Sanguinelli 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-washington-3',
    name: 'Lemon - Washington 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Washington 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Washington 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-eureka-3',
    name: 'Lime - Eureka 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Eureka 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Eureka 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-lisbon-3',
    name: 'Grapefruit - Lisbon 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lisbon 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Lisbon 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-meyer-3',
    name: 'Mandarin - Meyer 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Meyer 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Meyer 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-ponderosa-3',
    name: 'Tangerine - Ponderosa 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Ponderosa 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Ponderosa 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-feminello-3',
    name: 'Kumquat - Feminello 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Feminello 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Feminello 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-genoa-3',
    name: 'Pomelo - Genoa 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Genoa 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Genoa 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-santa-teresa-3',
    name: 'Orange - Santa Teresa 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Santa Teresa 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Santa Teresa 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-villafranca-3',
    name: 'Lemon - Villafranca 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Villafranca 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Villafranca 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-yen-ben-3',
    name: 'Lime - Yen Ben 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Yen Ben 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Yen Ben 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-lisbon-3',
    name: 'Grapefruit - Lisbon 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lisbon 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Lisbon 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-persian-3',
    name: 'Mandarin - Persian 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Persian 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Persian 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-key-3',
    name: 'Tangerine - Key 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Key 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Key 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-kaffir-3',
    name: 'Kumquat - Kaffir 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Kaffir 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Kaffir 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-bearss-3',
    name: 'Pomelo - Bearss 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Bearss 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Bearss 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-tahiti-3',
    name: 'Orange - Tahiti 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tahiti 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tahiti 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-mexican-3',
    name: 'Lemon - Mexican 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Mexican 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Mexican 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-west-indian-3',
    name: 'Lime - West Indian 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'West Indian 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['West Indian 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-rangpur-3',
    name: 'Grapefruit - Rangpur 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Rangpur 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Rangpur 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-sweet-lime-3',
    name: 'Mandarin - Sweet Lime 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sweet Lime 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Sweet Lime 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-palestine-3',
    name: 'Tangerine - Palestine 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Palestine 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Palestine 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-ruby-red-3',
    name: 'Kumquat - Ruby Red 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Ruby Red 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Ruby Red 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-marsh-3',
    name: 'Pomelo - Marsh 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Marsh 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Marsh 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-star-ruby-3',
    name: 'Orange - Star Ruby 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Star Ruby 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Star Ruby 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-rio-red-3',
    name: 'Lemon - Rio Red 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Rio Red 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Rio Red 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-white-3',
    name: 'Lime - White 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'White 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['White 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-thompson-3',
    name: 'Grapefruit - Thompson 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Thompson 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Thompson 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-oro-blanco-3',
    name: 'Mandarin - Oro Blanco 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Oro Blanco 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Oro Blanco 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-melogold-3',
    name: 'Tangerine - Melogold 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Melogold 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Melogold 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-chandler-3',
    name: 'Kumquat - Chandler 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Chandler 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Chandler 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-wheeny-3',
    name: 'Pomelo - Wheeny 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Wheeny 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Wheeny 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-clementine-3',
    name: 'Orange - Clementine 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Clementine 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Clementine 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-satsuma-3',
    name: 'Lemon - Satsuma 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Satsuma 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Satsuma 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-tangelo-3',
    name: 'Lime - Tangelo 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tangelo 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tangelo 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-tangerine-3',
    name: 'Grapefruit - Tangerine 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tangerine 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tangerine 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-minneola-3',
    name: 'Mandarin - Minneola 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Minneola 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Minneola 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-honey-3',
    name: 'Tangerine - Honey 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Honey 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Honey 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-page-3',
    name: 'Kumquat - Page 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Page 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Page 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-fairchild-3',
    name: 'Pomelo - Fairchild 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Fairchild 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Fairchild 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-dancy-3',
    name: 'Orange - Dancy 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Dancy 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Dancy 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-robinson-3',
    name: 'Lemon - Robinson 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Robinson 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Robinson 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-sunburst-3',
    name: 'Lime - Sunburst 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sunburst 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Sunburst 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-murcott-3',
    name: 'Grapefruit - Murcott 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Murcott 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Murcott 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-fallglo-3',
    name: 'Mandarin - Fallglo 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Fallglo 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Fallglo 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-nova-3',
    name: 'Tangerine - Nova 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Nova 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Nova 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-osceola-3',
    name: 'Kumquat - Osceola 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Osceola 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Osceola 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-lee-3',
    name: 'Pomelo - Lee 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lee 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Lee 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-robinson-3',
    name: 'Orange - Robinson 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Robinson 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Robinson 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-fortune-3',
    name: 'Lemon - Fortune 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Fortune 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Fortune 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-orlando-3',
    name: 'Lime - Orlando 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Orlando 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Orlando 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-seminole-3',
    name: 'Grapefruit - Seminole 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Seminole 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Seminole 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-thornton-3',
    name: 'Mandarin - Thornton 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Thornton 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Thornton 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-umatilla-3',
    name: 'Tangerine - Umatilla 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Umatilla 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Umatilla 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-wilking-3',
    name: 'Kumquat - Wilking 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Wilking 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Wilking 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-algerian-3',
    name: 'Pomelo - Algerian 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Algerian 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Algerian 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-beauty-3',
    name: 'Orange - Beauty 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Beauty 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Beauty 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-calamondin-3',
    name: 'Lemon - Calamondin 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Calamondin 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Calamondin 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-kumquat-3',
    name: 'Lime - Kumquat 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Kumquat 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Kumquat 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-nagami-3',
    name: 'Grapefruit - Nagami 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Nagami 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Nagami 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-meiwa-3',
    name: 'Mandarin - Meiwa 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Meiwa 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Meiwa 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-marumi-3',
    name: 'Tangerine - Marumi 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Marumi 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Marumi 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-jiangsu-3',
    name: 'Kumquat - Jiangsu 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Jiangsu 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Jiangsu 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-hong-kong-3',
    name: 'Pomelo - Hong Kong 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Hong Kong 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Hong Kong 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-malayan-3',
    name: 'Orange - Malayan 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Malayan 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Malayan 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-nordmann-3',
    name: 'Lemon - Nordmann 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Nordmann 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Nordmann 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-oval-3',
    name: 'Lime - Oval 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Oval 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Oval 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-pomelo-3',
    name: 'Grapefruit - Pomelo 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Pomelo 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Pomelo 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-chandler-3',
    name: 'Mandarin - Chandler 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Chandler 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Chandler 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-reinking-3',
    name: 'Tangerine - Reinking 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Reinking 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Reinking 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-hirado-3',
    name: 'Kumquat - Hirado 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Hirado 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Hirado 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-melogold-3',
    name: 'Pomelo - Melogold 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Melogold 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Melogold 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-oroblanco-3',
    name: 'Orange - Oroblanco 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Oroblanco 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Oroblanco 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-jaffa-3',
    name: 'Lemon - Jaffa 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Jaffa 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Jaffa 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-joppa-3',
    name: 'Lime - Joppa 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Joppa 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Joppa 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-shamouti-3',
    name: 'Grapefruit - Shamouti 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Shamouti 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Shamouti 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-blood-3',
    name: 'Mandarin - Blood 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Blood 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Blood 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-jaffa-blood-3',
    name: 'Tangerine - Jaffa Blood 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Jaffa Blood 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Jaffa Blood 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-maltese-3',
    name: 'Kumquat - Maltese 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Maltese 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Maltese 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-moro-3',
    name: 'Pomelo - Moro 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Moro 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Moro 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-sanguinello-3',
    name: 'Orange - Sanguinello 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Sanguinello 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Sanguinello 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-tarocco-3',
    name: 'Lemon - Tarocco 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Tarocco 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Tarocco 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-valencia-late-3',
    name: 'Lime - Valencia Late 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Valencia Late 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Valencia Late 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-verna-3',
    name: 'Grapefruit - Verna 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Verna 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Verna 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'mandarin-vicieda-3',
    name: 'Mandarin - Vicieda 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Vicieda 3 mandarin. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Vicieda 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'tangerine-washington-navel-3',
    name: 'Tangerine - Washington Navel 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Washington Navel 3 tangerine. Easy-peel, sweet segments, perfect snack. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Washington Navel 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'kumquat-xuegan-3',
    name: 'Kumquat - Xuegan 3',
    scientificName: 'Citrus japonica',
    category: 'tree',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Xuegan 3 kumquat. Tiny sweet-tart fruits, edible peel. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '6-8 feet',
    family: 'Rutaceae',
    varieties: ['Xuegan 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'pomelo-cocktail-3',
    name: 'Pomelo - Cocktail 3',
    scientificName: 'Citrus maxima',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Cocktail 3 pomelo. Largest citrus, mild and sweet. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Cocktail 3'],
    uses: ['fresh', 'breakfast', 'salads']
  },
  {
    id: 'orange-limequat-3',
    name: 'Orange - Limequat 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Limequat 3 orange. Sweet and juicy, perfect for fresh juice. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Limequat 3'],
    uses: ['fresh', 'juice', 'snacking']
  },
  {
    id: 'lemon-orangequat-3',
    name: 'Lemon - Orangequat 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Orangequat 3 lemon. Tart and acidic, essential for cooking. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Orangequat 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'lime-lemonquat-3',
    name: 'Lime - Lemonquat 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Lemonquat 3 lime. Zesty and aromatic, key for cocktails. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Lemonquat 3'],
    uses: ['cooking', 'cocktails', 'preserving']
  },
  {
    id: 'grapefruit-calamondin-3',
    name: 'Grapefruit - Calamondin 3',
    scientificName: 'Citrus sinensis',
    category: 'tree',
    spacing: 120,
    rowSpacing: 144,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Calamondin 3 grapefruit. Tangy and refreshing, great for breakfast. Container suitable in cold climates.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-20 feet',
    spread: '12-15 feet',
    family: 'Rutaceae',
    varieties: ['Calamondin 3'],
    uses: ['fresh', 'breakfast', 'salads']
  }
,
  {
    id: 'mango-tommy-atkins',
    name: 'Mango - Tommy Atkins',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tommy Atkins mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Tommy Atkins'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-kent',
    name: 'Papaya - Kent',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kent papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Kent'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-keitt',
    name: 'Pineapple - Keitt',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Keitt pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Keitt'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-ataulfo',
    name: 'Banana - Ataulfo',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Ataulfo banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Ataulfo'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-haden',
    name: 'Avocado - Haden',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Haden avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Haden'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-alphonso',
    name: 'Guava - Alphonso',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alphonso guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Alphonso'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-francis',
    name: 'Passion fruit - Francis',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Francis passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Francis'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-valencia-pride',
    name: 'Dragon fruit - Valencia Pride',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Valencia Pride dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Valencia Pride'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-glenn',
    name: 'Lychee - Glenn',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Glenn lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Glenn'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-irwin',
    name: 'Rambutan - Irwin',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Irwin rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Irwin'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-solo',
    name: 'Durian - Solo',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Solo'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-sunup',
    name: 'Jackfruit - SunUp',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'SunUp jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['SunUp'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-sunset',
    name: 'Star fruit - Sunset',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sunset star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Sunset'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-waimanalo',
    name: 'Sapodilla - Waimanalo',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Waimanalo sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Waimanalo'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-kamiya',
    name: 'Mamey - Kamiya',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kamiya mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Kamiya'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-smooth-cayenne',
    name: 'Mango - Smooth Cayenne',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth Cayenne mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Smooth Cayenne'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-md-2',
    name: 'Papaya - MD-2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'MD-2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['MD-2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-del-monte-gold',
    name: 'Pineapple - Del Monte Gold',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Del Monte Gold pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Del Monte Gold'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-sugar-loaf',
    name: 'Banana - Sugar Loaf',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Sugar Loaf banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Sugar Loaf'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-abacaxi',
    name: 'Avocado - Abacaxi',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Abacaxi avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Abacaxi'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-dwarf-cavendish',
    name: 'Guava - Dwarf Cavendish',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf Cavendish guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dwarf Cavendish'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-grand-nain',
    name: 'Passion fruit - Grand Nain',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grand Nain passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Grand Nain'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-williams',
    name: 'Dragon fruit - Williams',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Williams dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Williams'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-lady-finger',
    name: 'Lychee - Lady Finger',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lady Finger lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Lady Finger'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-blue-java',
    name: 'Rambutan - Blue Java',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Blue Java rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Blue Java'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-hass',
    name: 'Durian - Hass',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hass durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Hass'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-fuerte',
    name: 'Jackfruit - Fuerte',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fuerte jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Fuerte'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-bacon',
    name: 'Star fruit - Bacon',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bacon star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Bacon'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-zutano',
    name: 'Sapodilla - Zutano',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Zutano sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Zutano'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-reed',
    name: 'Mamey - Reed',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Reed mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Reed'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-lamb-hass',
    name: 'Mango - Lamb Hass',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lamb Hass mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Lamb Hass'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-pinkerton',
    name: 'Papaya - Pinkerton',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pinkerton papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Pinkerton'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-gwen',
    name: 'Pineapple - Gwen',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gwen pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Gwen'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-whitsell',
    name: 'Banana - Whitsell',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Whitsell banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Whitsell'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-sir-prize',
    name: 'Avocado - Sir Prize',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sir Prize avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Sir Prize'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-strawberry',
    name: 'Guava - Strawberry',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Strawberry guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Strawberry'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-white',
    name: 'Passion fruit - White',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['White'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-red',
    name: 'Dragon fruit - Red',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Red'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-thai',
    name: 'Lychee - Thai',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Thai lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Thai'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-ruby',
    name: 'Rambutan - Ruby',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ruby rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Ruby'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-purple-possum',
    name: 'Durian - Purple Possum',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Possum durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Purple Possum'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-panama-red',
    name: 'Jackfruit - Panama Red',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Panama Red jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Panama Red'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-panama-gold',
    name: 'Star fruit - Panama Gold',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Panama Gold star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Panama Gold'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-nellie-kelly',
    name: 'Sapodilla - Nellie Kelly',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nellie Kelly sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Nellie Kelly'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-frederick',
    name: 'Mamey - Frederick',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frederick mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Frederick'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-vietnamese-white',
    name: 'Mango - Vietnamese White',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vietnamese White mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Vietnamese White'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-physical-graffiti',
    name: 'Papaya - Physical Graffiti',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Physical Graffiti papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Physical Graffiti'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-american-beauty',
    name: 'Pineapple - American Beauty',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'American Beauty pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['American Beauty'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-yellow',
    name: 'Banana - Yellow',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Yellow banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Yellow'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-colombian',
    name: 'Avocado - Colombian',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Colombian avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Colombian'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-brewster',
    name: 'Guava - Brewster',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brewster guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Brewster'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-mauritius',
    name: 'Passion fruit - Mauritius',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mauritius passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Mauritius'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-sweet-heart',
    name: 'Dragon fruit - Sweet Heart',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet Heart dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Sweet Heart'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-hak-ip',
    name: 'Lychee - Hak Ip',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hak Ip lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Hak Ip'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-no-mai-tsze',
    name: 'Rambutan - No Mai Tsze',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'No Mai Tsze rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['No Mai Tsze'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-rongrien',
    name: 'Durian - Rongrien',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rongrien durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Rongrien'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-binjai',
    name: 'Jackfruit - Binjai',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Binjai jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Binjai'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-chokanan',
    name: 'Star fruit - Chokanan',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chokanan star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Chokanan'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-nam-doc-mai',
    name: 'Sapodilla - Nam Doc Mai',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nam Doc Mai sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Nam Doc Mai'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-dashehari',
    name: 'Mamey - Dashehari',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dashehari mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dashehari'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-monthong',
    name: 'Mango - Monthong',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monthong mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Monthong'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-chanee',
    name: 'Papaya - Chanee',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chanee papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Chanee'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-musang-king',
    name: 'Pineapple - Musang King',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Musang King pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Musang King'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-d24',
    name: 'Banana - D24',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'D24 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['D24'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-d101',
    name: 'Avocado - D101',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'D101 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['D101'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-j-31',
    name: 'Guava - J-31',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'J-31 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['J-31'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-black-gold',
    name: 'Passion fruit - Black Gold',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Gold passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Black Gold'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-cheena',
    name: 'Dragon fruit - Cheena',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cheena dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Cheena'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-golden-pillow',
    name: 'Lychee - Golden Pillow',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden Pillow lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Golden Pillow'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-monthong',
    name: 'Rambutan - Monthong',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monthong rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Monthong'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-nangka',
    name: 'Durian - Nangka',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nangka durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Nangka'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-cempedak',
    name: 'Jackfruit - Cempedak',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cempedak jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Cempedak'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-honey-gold',
    name: 'Star fruit - Honey Gold',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Honey Gold star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Honey Gold'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-black-jack',
    name: 'Sapodilla - Black Jack',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Jack sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Black Jack'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-dang-rasimi',
    name: 'Mamey - Dang Rasimi',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dang Rasimi mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dang Rasimi'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-arkin',
    name: 'Mango - Arkin',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Arkin mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Arkin'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-fwang-tung',
    name: 'Papaya - Fwang Tung',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fwang Tung papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Fwang Tung'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-kari',
    name: 'Pineapple - Kari',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kari pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Kari'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-lara',
    name: 'Banana - Lara',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Lara banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Lara'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-sri-kembangan',
    name: 'Avocado - Sri Kembangan',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sri Kembangan avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Sri Kembangan'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-hasya',
    name: 'Guava - Hasya',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hasya guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Hasya'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-alano',
    name: 'Passion fruit - Alano',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alano passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Alano'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-morena',
    name: 'Dragon fruit - Morena',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Morena dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Morena'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-tikal',
    name: 'Lychee - Tikal',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tikal lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Tikal'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-prolific',
    name: 'Rambutan - Prolific',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prolific rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Prolific'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-magana',
    name: 'Durian - Magana',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Magana durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Magana'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-pace',
    name: 'Jackfruit - Pace',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pace jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Pace'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-pantin',
    name: 'Star fruit - Pantin',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pantin star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Pantin'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-mamey',
    name: 'Sapodilla - Mamey',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mamey sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Mamey'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-key-west',
    name: 'Mamey - Key West',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Key West mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Key West'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-atemoya',
    name: 'Mango - Atemoya',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Atemoya mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Atemoya'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-cherimoya',
    name: 'Papaya - Cherimoya',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cherimoya papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Cherimoya'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-sugar-apple',
    name: 'Pineapple - Sugar Apple',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sugar Apple pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Sugar Apple'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-custard-apple',
    name: 'Banana - Custard Apple',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Custard Apple banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Custard Apple'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-ilama',
    name: 'Avocado - Ilama',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ilama avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Ilama'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-soursop',
    name: 'Guava - Soursop',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Soursop guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Soursop'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-guanabana',
    name: 'Passion fruit - Guanabana',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Guanabana passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Guanabana'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-graviola',
    name: 'Dragon fruit - Graviola',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Graviola dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Graviola'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-biriba',
    name: 'Lychee - Biriba',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Biriba lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Biriba'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-wild-sugar-apple',
    name: 'Rambutan - Wild Sugar Apple',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wild Sugar Apple rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Wild Sugar Apple'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-rambutan',
    name: 'Durian - Rambutan',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rambutan durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Rambutan'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-pulasan',
    name: 'Jackfruit - Pulasan',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pulasan jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Pulasan'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-longan',
    name: 'Star fruit - Longan',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Longan star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Longan'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-dimocarpus',
    name: 'Sapodilla - Dimocarpus',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dimocarpus sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dimocarpus'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-kohala',
    name: 'Mamey - Kohala',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kohala mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Kohala'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-salak',
    name: 'Mango - Salak',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Salak mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Salak'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-snake-fruit',
    name: 'Papaya - Snake Fruit',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Snake Fruit papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Snake Fruit'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-mangosteen',
    name: 'Pineapple - Mangosteen',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mangosteen pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Mangosteen'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-queen-of-fruits',
    name: 'Banana - Queen of Fruits',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Queen of Fruits banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Queen of Fruits'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-purple-mangosteen',
    name: 'Avocado - Purple Mangosteen',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Mangosteen avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Purple Mangosteen'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-langsat',
    name: 'Guava - Langsat',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Langsat guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Langsat'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-duku',
    name: 'Passion fruit - Duku',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Duku passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Duku'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-longkong',
    name: 'Dragon fruit - Longkong',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Longkong dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Longkong'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-santol',
    name: 'Lychee - Santol',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Santol lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Santol'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-cotton-fruit',
    name: 'Rambutan - Cotton Fruit',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cotton Fruit rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Cotton Fruit'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-chico',
    name: 'Durian - Chico',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chico durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Chico'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-sapodilla',
    name: 'Jackfruit - Sapodilla',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sapodilla jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Sapodilla'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-naseberry',
    name: 'Star fruit - Naseberry',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Naseberry star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Naseberry'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-dilly',
    name: 'Sapodilla - Dilly',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dilly sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dilly'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-sawo',
    name: 'Mamey - Sawo',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sawo mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Sawo'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-canistel',
    name: 'Mango - Canistel',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Canistel mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Canistel'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-egg-fruit',
    name: 'Papaya - Egg Fruit',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Egg Fruit papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Egg Fruit'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-yellow-sapote',
    name: 'Pineapple - Yellow Sapote',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow Sapote pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Yellow Sapote'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-black-sapote',
    name: 'Banana - Black Sapote',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Black Sapote banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Black Sapote'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-chocolate-pudding-fruit',
    name: 'Avocado - Chocolate Pudding Fruit',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chocolate Pudding Fruit avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Chocolate Pudding Fruit'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-white-sapote',
    name: 'Guava - White Sapote',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White Sapote guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['White Sapote'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-mexican-apple',
    name: 'Passion fruit - Mexican Apple',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mexican Apple passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Mexican Apple'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-casimiroa',
    name: 'Dragon fruit - Casimiroa',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Casimiroa dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Casimiroa'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-green-sapote',
    name: 'Lychee - Green Sapote',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Sapote lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Green Sapote'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-matisia',
    name: 'Rambutan - Matisia',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Matisia rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Matisia'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-jaboticaba',
    name: 'Durian - Jaboticaba',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jaboticaba durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Jaboticaba'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-brazilian-grape-tree',
    name: 'Jackfruit - Brazilian Grape Tree',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brazilian Grape Tree jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Brazilian Grape Tree'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-camu-camu',
    name: 'Star fruit - Camu Camu',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Camu Camu star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Camu Camu'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-myrciaria',
    name: 'Sapodilla - Myrciaria',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Myrciaria sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Myrciaria'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-acerola',
    name: 'Mamey - Acerola',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Acerola mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Acerola'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-barbados-cherry',
    name: 'Mango - Barbados Cherry',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Barbados Cherry mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Barbados Cherry'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-malpighia',
    name: 'Papaya - Malpighia',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Malpighia papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Malpighia'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-cupuacu',
    name: 'Pineapple - Cupuacu',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cupuacu pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Cupuacu'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-theobroma',
    name: 'Banana - Theobroma',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Theobroma banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Theobroma'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-bacuri',
    name: 'Avocado - Bacuri',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bacuri avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Bacuri'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-uva',
    name: 'Guava - Uva',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Uva guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Uva'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-spanish-tamarind',
    name: 'Passion fruit - Spanish Tamarind',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish Tamarind passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Spanish Tamarind'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-mamoncillo',
    name: 'Dragon fruit - Mamoncillo',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mamoncillo dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Mamoncillo'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-genip',
    name: 'Lychee - Genip',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Genip lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Genip'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-spanish-lime',
    name: 'Rambutan - Spanish Lime',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish Lime rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Spanish Lime'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-jocote',
    name: 'Durian - Jocote',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jocote durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Jocote'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-hog-plum',
    name: 'Jackfruit - Hog Plum',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hog Plum jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Hog Plum'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-purple-mombin',
    name: 'Star fruit - Purple Mombin',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Mombin star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Purple Mombin'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-red-mombin',
    name: 'Sapodilla - Red Mombin',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Mombin sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Red Mombin'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-yellow-mombin',
    name: 'Mamey - Yellow Mombin',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow Mombin mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Yellow Mombin'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-imbe',
    name: 'Mango - Imbe',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Imbe mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Imbe'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-african-mangosteen',
    name: 'Papaya - African Mangosteen',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'African Mangosteen papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['African Mangosteen'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-garcinia',
    name: 'Pineapple - Garcinia',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Garcinia pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Garcinia'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-livingstone-potato',
    name: 'Banana - Livingstone Potato',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Livingstone Potato banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Livingstone Potato'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-plectranthus',
    name: 'Avocado - Plectranthus',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Plectranthus avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Plectranthus'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-tamarillo',
    name: 'Guava - Tamarillo',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tamarillo guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Tamarillo'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-tree-tomato',
    name: 'Passion fruit - Tree Tomato',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tree Tomato passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Tree Tomato'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-cyphomandra',
    name: 'Dragon fruit - Cyphomandra',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cyphomandra dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Cyphomandra'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-pepino',
    name: 'Lychee - Pepino',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pepino lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Pepino'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-melon-pear',
    name: 'Rambutan - Melon Pear',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Melon Pear rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Melon Pear'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-naranjilla',
    name: 'Durian - Naranjilla',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Naranjilla durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Naranjilla'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-lulo',
    name: 'Jackfruit - Lulo',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lulo jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Lulo'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-solanum',
    name: 'Star fruit - Solanum',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solanum star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Solanum'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-cocona',
    name: 'Sapodilla - Cocona',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cocona sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Cocona'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-orinoco-apple',
    name: 'Mamey - Orinoco Apple',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Orinoco Apple mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Orinoco Apple'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-araza',
    name: 'Mango - Araza',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Araza mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Araza'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-amazon-tree-grape',
    name: 'Papaya - Amazon Tree Grape',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Amazon Tree Grape papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Amazon Tree Grape'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-uvilla',
    name: 'Pineapple - Uvilla',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Uvilla pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Uvilla'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-golden-berry',
    name: 'Banana - Golden Berry',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Golden Berry banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Golden Berry'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-physalis',
    name: 'Avocado - Physalis',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Physalis avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Physalis'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-achacha',
    name: 'Guava - Achacha',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Achacha guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Achacha'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-bolivian-mangosteen',
    name: 'Passion fruit - Bolivian Mangosteen',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bolivian Mangosteen passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Bolivian Mangosteen'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-garcinia-humilis',
    name: 'Dragon fruit - Garcinia Humilis',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Garcinia Humilis dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Garcinia Humilis'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-kei-apple',
    name: 'Lychee - Kei Apple',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kei Apple lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Kei Apple'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-dovyalis',
    name: 'Rambutan - Dovyalis',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dovyalis rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dovyalis'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-jujube',
    name: 'Durian - Jujube',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jujube durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Jujube'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-chinese-date',
    name: 'Jackfruit - Chinese Date',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese Date jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Chinese Date'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-ber',
    name: 'Star fruit - Ber',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ber star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Ber'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-indian-plum',
    name: 'Sapodilla - Indian Plum',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Indian Plum sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Indian Plum'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-monkey-apple',
    name: 'Mamey - Monkey Apple',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monkey Apple mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Monkey Apple'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-tommy-atkins-2',
    name: 'Mango - Tommy Atkins 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tommy Atkins 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Tommy Atkins 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-kent-2',
    name: 'Papaya - Kent 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kent 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Kent 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-keitt-2',
    name: 'Pineapple - Keitt 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Keitt 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Keitt 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-ataulfo-2',
    name: 'Banana - Ataulfo 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Ataulfo 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Ataulfo 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-haden-2',
    name: 'Avocado - Haden 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Haden 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Haden 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-alphonso-2',
    name: 'Guava - Alphonso 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alphonso 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Alphonso 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-francis-2',
    name: 'Passion fruit - Francis 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Francis 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Francis 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-valencia-pride-2',
    name: 'Dragon fruit - Valencia Pride 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Valencia Pride 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Valencia Pride 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-glenn-2',
    name: 'Lychee - Glenn 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Glenn 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Glenn 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-irwin-2',
    name: 'Rambutan - Irwin 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Irwin 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Irwin 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-solo-2',
    name: 'Durian - Solo 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Solo 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-sunup-2',
    name: 'Jackfruit - SunUp 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'SunUp 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['SunUp 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-sunset-2',
    name: 'Star fruit - Sunset 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sunset 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Sunset 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-waimanalo-2',
    name: 'Sapodilla - Waimanalo 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Waimanalo 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Waimanalo 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-kamiya-2',
    name: 'Mamey - Kamiya 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kamiya 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Kamiya 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-smooth-cayenne-2',
    name: 'Mango - Smooth Cayenne 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth Cayenne 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Smooth Cayenne 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-md-2-2',
    name: 'Papaya - MD-2 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'MD-2 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['MD-2 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-del-monte-gold-2',
    name: 'Pineapple - Del Monte Gold 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Del Monte Gold 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Del Monte Gold 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-sugar-loaf-2',
    name: 'Banana - Sugar Loaf 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Sugar Loaf 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Sugar Loaf 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-abacaxi-2',
    name: 'Avocado - Abacaxi 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Abacaxi 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Abacaxi 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-dwarf-cavendish-2',
    name: 'Guava - Dwarf Cavendish 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf Cavendish 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dwarf Cavendish 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-grand-nain-2',
    name: 'Passion fruit - Grand Nain 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grand Nain 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Grand Nain 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-williams-2',
    name: 'Dragon fruit - Williams 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Williams 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Williams 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-lady-finger-2',
    name: 'Lychee - Lady Finger 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lady Finger 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Lady Finger 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-blue-java-2',
    name: 'Rambutan - Blue Java 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Blue Java 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Blue Java 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-hass-2',
    name: 'Durian - Hass 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hass 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Hass 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-fuerte-2',
    name: 'Jackfruit - Fuerte 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fuerte 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Fuerte 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-bacon-2',
    name: 'Star fruit - Bacon 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bacon 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Bacon 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-zutano-2',
    name: 'Sapodilla - Zutano 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Zutano 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Zutano 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-reed-2',
    name: 'Mamey - Reed 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Reed 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Reed 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-lamb-hass-2',
    name: 'Mango - Lamb Hass 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lamb Hass 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Lamb Hass 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-pinkerton-2',
    name: 'Papaya - Pinkerton 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pinkerton 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Pinkerton 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-gwen-2',
    name: 'Pineapple - Gwen 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gwen 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Gwen 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-whitsell-2',
    name: 'Banana - Whitsell 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Whitsell 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Whitsell 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-sir-prize-2',
    name: 'Avocado - Sir Prize 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sir Prize 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Sir Prize 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-strawberry-2',
    name: 'Guava - Strawberry 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Strawberry 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Strawberry 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-white-2',
    name: 'Passion fruit - White 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['White 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-red-2',
    name: 'Dragon fruit - Red 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Red 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-thai-2',
    name: 'Lychee - Thai 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Thai 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Thai 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-ruby-2',
    name: 'Rambutan - Ruby 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ruby 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Ruby 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-purple-possum-2',
    name: 'Durian - Purple Possum 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Possum 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Purple Possum 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-panama-red-2',
    name: 'Jackfruit - Panama Red 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Panama Red 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Panama Red 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-panama-gold-2',
    name: 'Star fruit - Panama Gold 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Panama Gold 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Panama Gold 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-nellie-kelly-2',
    name: 'Sapodilla - Nellie Kelly 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nellie Kelly 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Nellie Kelly 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-frederick-2',
    name: 'Mamey - Frederick 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frederick 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Frederick 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-vietnamese-white-2',
    name: 'Mango - Vietnamese White 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vietnamese White 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Vietnamese White 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-physical-graffiti-2',
    name: 'Papaya - Physical Graffiti 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Physical Graffiti 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Physical Graffiti 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-american-beauty-2',
    name: 'Pineapple - American Beauty 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'American Beauty 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['American Beauty 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-yellow-2',
    name: 'Banana - Yellow 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Yellow 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Yellow 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-colombian-2',
    name: 'Avocado - Colombian 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Colombian 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Colombian 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-brewster-2',
    name: 'Guava - Brewster 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brewster 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Brewster 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-mauritius-2',
    name: 'Passion fruit - Mauritius 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mauritius 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Mauritius 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-sweet-heart-2',
    name: 'Dragon fruit - Sweet Heart 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet Heart 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Sweet Heart 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-hak-ip-2',
    name: 'Lychee - Hak Ip 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hak Ip 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Hak Ip 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-no-mai-tsze-2',
    name: 'Rambutan - No Mai Tsze 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'No Mai Tsze 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['No Mai Tsze 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-rongrien-2',
    name: 'Durian - Rongrien 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rongrien 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Rongrien 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-binjai-2',
    name: 'Jackfruit - Binjai 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Binjai 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Binjai 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-chokanan-2',
    name: 'Star fruit - Chokanan 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chokanan 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Chokanan 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-nam-doc-mai-2',
    name: 'Sapodilla - Nam Doc Mai 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nam Doc Mai 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Nam Doc Mai 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-dashehari-2',
    name: 'Mamey - Dashehari 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dashehari 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dashehari 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-monthong-2',
    name: 'Mango - Monthong 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monthong 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Monthong 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-chanee-2',
    name: 'Papaya - Chanee 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chanee 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Chanee 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-musang-king-2',
    name: 'Pineapple - Musang King 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Musang King 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Musang King 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-d24-2',
    name: 'Banana - D24 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'D24 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['D24 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-d101-2',
    name: 'Avocado - D101 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'D101 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['D101 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-j-31-2',
    name: 'Guava - J-31 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'J-31 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['J-31 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-black-gold-2',
    name: 'Passion fruit - Black Gold 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Gold 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Black Gold 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-cheena-2',
    name: 'Dragon fruit - Cheena 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cheena 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Cheena 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-golden-pillow-2',
    name: 'Lychee - Golden Pillow 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden Pillow 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Golden Pillow 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-monthong-2',
    name: 'Rambutan - Monthong 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monthong 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Monthong 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-nangka-2',
    name: 'Durian - Nangka 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nangka 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Nangka 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-cempedak-2',
    name: 'Jackfruit - Cempedak 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cempedak 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Cempedak 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-honey-gold-2',
    name: 'Star fruit - Honey Gold 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Honey Gold 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Honey Gold 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-black-jack-2',
    name: 'Sapodilla - Black Jack 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Jack 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Black Jack 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-dang-rasimi-2',
    name: 'Mamey - Dang Rasimi 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dang Rasimi 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dang Rasimi 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-arkin-2',
    name: 'Mango - Arkin 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Arkin 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Arkin 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-fwang-tung-2',
    name: 'Papaya - Fwang Tung 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fwang Tung 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Fwang Tung 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-kari-2',
    name: 'Pineapple - Kari 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kari 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Kari 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-lara-2',
    name: 'Banana - Lara 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Lara 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Lara 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-sri-kembangan-2',
    name: 'Avocado - Sri Kembangan 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sri Kembangan 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Sri Kembangan 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-hasya-2',
    name: 'Guava - Hasya 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hasya 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Hasya 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-alano-2',
    name: 'Passion fruit - Alano 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alano 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Alano 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-morena-2',
    name: 'Dragon fruit - Morena 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Morena 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Morena 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-tikal-2',
    name: 'Lychee - Tikal 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tikal 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Tikal 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-prolific-2',
    name: 'Rambutan - Prolific 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prolific 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Prolific 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-magana-2',
    name: 'Durian - Magana 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Magana 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Magana 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-pace-2',
    name: 'Jackfruit - Pace 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pace 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Pace 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-pantin-2',
    name: 'Star fruit - Pantin 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pantin 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Pantin 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-mamey-2',
    name: 'Sapodilla - Mamey 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mamey 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Mamey 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-key-west-2',
    name: 'Mamey - Key West 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Key West 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Key West 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-atemoya-2',
    name: 'Mango - Atemoya 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Atemoya 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Atemoya 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-cherimoya-2',
    name: 'Papaya - Cherimoya 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cherimoya 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Cherimoya 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-sugar-apple-2',
    name: 'Pineapple - Sugar Apple 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sugar Apple 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Sugar Apple 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-custard-apple-2',
    name: 'Banana - Custard Apple 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Custard Apple 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Custard Apple 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-ilama-2',
    name: 'Avocado - Ilama 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ilama 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Ilama 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-soursop-2',
    name: 'Guava - Soursop 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Soursop 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Soursop 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-guanabana-2',
    name: 'Passion fruit - Guanabana 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Guanabana 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Guanabana 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-graviola-2',
    name: 'Dragon fruit - Graviola 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Graviola 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Graviola 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-biriba-2',
    name: 'Lychee - Biriba 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Biriba 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Biriba 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-wild-sugar-apple-2',
    name: 'Rambutan - Wild Sugar Apple 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wild Sugar Apple 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Wild Sugar Apple 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-rambutan-2',
    name: 'Durian - Rambutan 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rambutan 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Rambutan 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-pulasan-2',
    name: 'Jackfruit - Pulasan 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pulasan 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Pulasan 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-longan-2',
    name: 'Star fruit - Longan 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Longan 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Longan 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-dimocarpus-2',
    name: 'Sapodilla - Dimocarpus 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dimocarpus 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dimocarpus 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-kohala-2',
    name: 'Mamey - Kohala 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kohala 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Kohala 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-salak-2',
    name: 'Mango - Salak 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Salak 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Salak 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-snake-fruit-2',
    name: 'Papaya - Snake Fruit 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Snake Fruit 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Snake Fruit 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-mangosteen-2',
    name: 'Pineapple - Mangosteen 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mangosteen 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Mangosteen 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-queen-of-fruits-2',
    name: 'Banana - Queen of Fruits 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Queen of Fruits 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Queen of Fruits 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-purple-mangosteen-2',
    name: 'Avocado - Purple Mangosteen 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Mangosteen 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Purple Mangosteen 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-langsat-2',
    name: 'Guava - Langsat 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Langsat 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Langsat 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-duku-2',
    name: 'Passion fruit - Duku 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Duku 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Duku 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-longkong-2',
    name: 'Dragon fruit - Longkong 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Longkong 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Longkong 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-santol-2',
    name: 'Lychee - Santol 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Santol 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Santol 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-cotton-fruit-2',
    name: 'Rambutan - Cotton Fruit 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cotton Fruit 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Cotton Fruit 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-chico-2',
    name: 'Durian - Chico 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chico 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Chico 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-sapodilla-2',
    name: 'Jackfruit - Sapodilla 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sapodilla 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Sapodilla 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-naseberry-2',
    name: 'Star fruit - Naseberry 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Naseberry 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Naseberry 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-dilly-2',
    name: 'Sapodilla - Dilly 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dilly 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dilly 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-sawo-2',
    name: 'Mamey - Sawo 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sawo 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Sawo 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-canistel-2',
    name: 'Mango - Canistel 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Canistel 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Canistel 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-egg-fruit-2',
    name: 'Papaya - Egg Fruit 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Egg Fruit 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Egg Fruit 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-yellow-sapote-2',
    name: 'Pineapple - Yellow Sapote 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow Sapote 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Yellow Sapote 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-black-sapote-2',
    name: 'Banana - Black Sapote 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Black Sapote 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Black Sapote 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-chocolate-pudding-fruit-2',
    name: 'Avocado - Chocolate Pudding Fruit 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chocolate Pudding Fruit 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Chocolate Pudding Fruit 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-white-sapote-2',
    name: 'Guava - White Sapote 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White Sapote 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['White Sapote 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-mexican-apple-2',
    name: 'Passion fruit - Mexican Apple 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mexican Apple 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Mexican Apple 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-casimiroa-2',
    name: 'Dragon fruit - Casimiroa 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Casimiroa 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Casimiroa 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-green-sapote-2',
    name: 'Lychee - Green Sapote 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Sapote 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Green Sapote 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-matisia-2',
    name: 'Rambutan - Matisia 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Matisia 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Matisia 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-jaboticaba-2',
    name: 'Durian - Jaboticaba 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jaboticaba 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Jaboticaba 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-brazilian-grape-tree-2',
    name: 'Jackfruit - Brazilian Grape Tree 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brazilian Grape Tree 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Brazilian Grape Tree 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-camu-camu-2',
    name: 'Star fruit - Camu Camu 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Camu Camu 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Camu Camu 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-myrciaria-2',
    name: 'Sapodilla - Myrciaria 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Myrciaria 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Myrciaria 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-acerola-2',
    name: 'Mamey - Acerola 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Acerola 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Acerola 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-barbados-cherry-2',
    name: 'Mango - Barbados Cherry 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Barbados Cherry 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Barbados Cherry 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-malpighia-2',
    name: 'Papaya - Malpighia 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Malpighia 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Malpighia 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-cupuacu-2',
    name: 'Pineapple - Cupuacu 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cupuacu 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Cupuacu 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-theobroma-2',
    name: 'Banana - Theobroma 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Theobroma 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Theobroma 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-bacuri-2',
    name: 'Avocado - Bacuri 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bacuri 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Bacuri 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-uva-2',
    name: 'Guava - Uva 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Uva 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Uva 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-spanish-tamarind-2',
    name: 'Passion fruit - Spanish Tamarind 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish Tamarind 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Spanish Tamarind 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-mamoncillo-2',
    name: 'Dragon fruit - Mamoncillo 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mamoncillo 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Mamoncillo 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-genip-2',
    name: 'Lychee - Genip 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Genip 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Genip 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-spanish-lime-2',
    name: 'Rambutan - Spanish Lime 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish Lime 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Spanish Lime 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-jocote-2',
    name: 'Durian - Jocote 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jocote 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Jocote 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-hog-plum-2',
    name: 'Jackfruit - Hog Plum 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hog Plum 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Hog Plum 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-purple-mombin-2',
    name: 'Star fruit - Purple Mombin 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Mombin 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Purple Mombin 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-red-mombin-2',
    name: 'Sapodilla - Red Mombin 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Mombin 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Red Mombin 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-yellow-mombin-2',
    name: 'Mamey - Yellow Mombin 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow Mombin 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Yellow Mombin 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-imbe-2',
    name: 'Mango - Imbe 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Imbe 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Imbe 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-african-mangosteen-2',
    name: 'Papaya - African Mangosteen 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'African Mangosteen 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['African Mangosteen 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-garcinia-2',
    name: 'Pineapple - Garcinia 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Garcinia 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Garcinia 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-livingstone-potato-2',
    name: 'Banana - Livingstone Potato 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Livingstone Potato 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Livingstone Potato 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-plectranthus-2',
    name: 'Avocado - Plectranthus 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Plectranthus 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Plectranthus 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-tamarillo-2',
    name: 'Guava - Tamarillo 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tamarillo 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Tamarillo 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-tree-tomato-2',
    name: 'Passion fruit - Tree Tomato 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tree Tomato 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Tree Tomato 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-cyphomandra-2',
    name: 'Dragon fruit - Cyphomandra 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cyphomandra 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Cyphomandra 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-pepino-2',
    name: 'Lychee - Pepino 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pepino 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Pepino 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-melon-pear-2',
    name: 'Rambutan - Melon Pear 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Melon Pear 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Melon Pear 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-naranjilla-2',
    name: 'Durian - Naranjilla 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Naranjilla 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Naranjilla 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-lulo-2',
    name: 'Jackfruit - Lulo 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lulo 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Lulo 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-solanum-2',
    name: 'Star fruit - Solanum 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solanum 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Solanum 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-cocona-2',
    name: 'Sapodilla - Cocona 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cocona 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Cocona 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-orinoco-apple-2',
    name: 'Mamey - Orinoco Apple 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Orinoco Apple 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Orinoco Apple 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-araza-2',
    name: 'Mango - Araza 2',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Araza 2 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Araza 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-amazon-tree-grape-2',
    name: 'Papaya - Amazon Tree Grape 2',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Amazon Tree Grape 2 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Amazon Tree Grape 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-uvilla-2',
    name: 'Pineapple - Uvilla 2',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Uvilla 2 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Uvilla 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-golden-berry-2',
    name: 'Banana - Golden Berry 2',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Golden Berry 2 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Golden Berry 2'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-physalis-2',
    name: 'Avocado - Physalis 2',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Physalis 2 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Physalis 2'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-achacha-2',
    name: 'Guava - Achacha 2',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Achacha 2 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Achacha 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-bolivian-mangosteen-2',
    name: 'Passion fruit - Bolivian Mangosteen 2',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bolivian Mangosteen 2 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Bolivian Mangosteen 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-garcinia-humilis-2',
    name: 'Dragon fruit - Garcinia Humilis 2',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Garcinia Humilis 2 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Garcinia Humilis 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-kei-apple-2',
    name: 'Lychee - Kei Apple 2',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kei Apple 2 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Kei Apple 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-dovyalis-2',
    name: 'Rambutan - Dovyalis 2',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dovyalis 2 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dovyalis 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-jujube-2',
    name: 'Durian - Jujube 2',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jujube 2 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Jujube 2'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-chinese-date-2',
    name: 'Jackfruit - Chinese Date 2',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese Date 2 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Chinese Date 2'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-ber-2',
    name: 'Star fruit - Ber 2',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ber 2 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Ber 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-indian-plum-2',
    name: 'Sapodilla - Indian Plum 2',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Indian Plum 2 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Indian Plum 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-monkey-apple-2',
    name: 'Mamey - Monkey Apple 2',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monkey Apple 2 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Monkey Apple 2'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-tommy-atkins-3',
    name: 'Mango - Tommy Atkins 3',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tommy Atkins 3 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Tommy Atkins 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-kent-3',
    name: 'Papaya - Kent 3',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kent 3 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Kent 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-keitt-3',
    name: 'Pineapple - Keitt 3',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Keitt 3 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Keitt 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-ataulfo-3',
    name: 'Banana - Ataulfo 3',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Ataulfo 3 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Ataulfo 3'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-haden-3',
    name: 'Avocado - Haden 3',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Haden 3 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Haden 3'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-alphonso-3',
    name: 'Guava - Alphonso 3',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alphonso 3 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Alphonso 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-francis-3',
    name: 'Passion fruit - Francis 3',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Francis 3 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Francis 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-valencia-pride-3',
    name: 'Dragon fruit - Valencia Pride 3',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Valencia Pride 3 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Valencia Pride 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-glenn-3',
    name: 'Lychee - Glenn 3',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Glenn 3 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Glenn 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-irwin-3',
    name: 'Rambutan - Irwin 3',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Irwin 3 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Irwin 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-solo-3',
    name: 'Durian - Solo 3',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 3 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Solo 3'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-sunup-3',
    name: 'Jackfruit - SunUp 3',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'SunUp 3 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['SunUp 3'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-sunset-3',
    name: 'Star fruit - Sunset 3',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sunset 3 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Sunset 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-waimanalo-3',
    name: 'Sapodilla - Waimanalo 3',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Waimanalo 3 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Waimanalo 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-kamiya-3',
    name: 'Mamey - Kamiya 3',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kamiya 3 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Kamiya 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-smooth-cayenne-3',
    name: 'Mango - Smooth Cayenne 3',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth Cayenne 3 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Smooth Cayenne 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-md-2-3',
    name: 'Papaya - MD-2 3',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'MD-2 3 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['MD-2 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-del-monte-gold-3',
    name: 'Pineapple - Del Monte Gold 3',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Del Monte Gold 3 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Del Monte Gold 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-sugar-loaf-3',
    name: 'Banana - Sugar Loaf 3',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Sugar Loaf 3 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Sugar Loaf 3'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-abacaxi-3',
    name: 'Avocado - Abacaxi 3',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Abacaxi 3 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Abacaxi 3'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-dwarf-cavendish-3',
    name: 'Guava - Dwarf Cavendish 3',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf Cavendish 3 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dwarf Cavendish 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-grand-nain-3',
    name: 'Passion fruit - Grand Nain 3',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grand Nain 3 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Grand Nain 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-williams-3',
    name: 'Dragon fruit - Williams 3',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Williams 3 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Williams 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-lady-finger-3',
    name: 'Lychee - Lady Finger 3',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lady Finger 3 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Lady Finger 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-blue-java-3',
    name: 'Rambutan - Blue Java 3',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Blue Java 3 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Blue Java 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-hass-3',
    name: 'Durian - Hass 3',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hass 3 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Hass 3'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-fuerte-3',
    name: 'Jackfruit - Fuerte 3',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fuerte 3 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Fuerte 3'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-bacon-3',
    name: 'Star fruit - Bacon 3',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bacon 3 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Bacon 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-zutano-3',
    name: 'Sapodilla - Zutano 3',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Zutano 3 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Zutano 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-reed-3',
    name: 'Mamey - Reed 3',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Reed 3 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Reed 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-lamb-hass-3',
    name: 'Mango - Lamb Hass 3',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lamb Hass 3 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Lamb Hass 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-pinkerton-3',
    name: 'Papaya - Pinkerton 3',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pinkerton 3 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Pinkerton 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-gwen-3',
    name: 'Pineapple - Gwen 3',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gwen 3 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Gwen 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-whitsell-3',
    name: 'Banana - Whitsell 3',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Whitsell 3 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Whitsell 3'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-sir-prize-3',
    name: 'Avocado - Sir Prize 3',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sir Prize 3 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Sir Prize 3'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-strawberry-3',
    name: 'Guava - Strawberry 3',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Strawberry 3 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Strawberry 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-white-3',
    name: 'Passion fruit - White 3',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White 3 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['White 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-red-3',
    name: 'Dragon fruit - Red 3',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 3 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Red 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-thai-3',
    name: 'Lychee - Thai 3',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Thai 3 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Thai 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-ruby-3',
    name: 'Rambutan - Ruby 3',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ruby 3 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Ruby 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-purple-possum-3',
    name: 'Durian - Purple Possum 3',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Possum 3 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Purple Possum 3'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-panama-red-3',
    name: 'Jackfruit - Panama Red 3',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Panama Red 3 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Panama Red 3'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-panama-gold-3',
    name: 'Star fruit - Panama Gold 3',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Panama Gold 3 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Panama Gold 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-nellie-kelly-3',
    name: 'Sapodilla - Nellie Kelly 3',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nellie Kelly 3 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Nellie Kelly 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-frederick-3',
    name: 'Mamey - Frederick 3',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frederick 3 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Frederick 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-vietnamese-white-3',
    name: 'Mango - Vietnamese White 3',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vietnamese White 3 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Vietnamese White 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-physical-graffiti-3',
    name: 'Papaya - Physical Graffiti 3',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Physical Graffiti 3 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Physical Graffiti 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-american-beauty-3',
    name: 'Pineapple - American Beauty 3',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'American Beauty 3 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['American Beauty 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-yellow-3',
    name: 'Banana - Yellow 3',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Yellow 3 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Yellow 3'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-colombian-3',
    name: 'Avocado - Colombian 3',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Colombian 3 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Colombian 3'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-brewster-3',
    name: 'Guava - Brewster 3',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brewster 3 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Brewster 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-mauritius-3',
    name: 'Passion fruit - Mauritius 3',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mauritius 3 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Mauritius 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-sweet-heart-3',
    name: 'Dragon fruit - Sweet Heart 3',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet Heart 3 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Sweet Heart 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-hak-ip-3',
    name: 'Lychee - Hak Ip 3',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hak Ip 3 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Hak Ip 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-no-mai-tsze-3',
    name: 'Rambutan - No Mai Tsze 3',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'No Mai Tsze 3 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['No Mai Tsze 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-rongrien-3',
    name: 'Durian - Rongrien 3',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rongrien 3 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Rongrien 3'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-binjai-3',
    name: 'Jackfruit - Binjai 3',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Binjai 3 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Binjai 3'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-chokanan-3',
    name: 'Star fruit - Chokanan 3',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chokanan 3 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Chokanan 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-nam-doc-mai-3',
    name: 'Sapodilla - Nam Doc Mai 3',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nam Doc Mai 3 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Nam Doc Mai 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-dashehari-3',
    name: 'Mamey - Dashehari 3',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dashehari 3 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dashehari 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-monthong-3',
    name: 'Mango - Monthong 3',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monthong 3 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Monthong 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-chanee-3',
    name: 'Papaya - Chanee 3',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chanee 3 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Chanee 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-musang-king-3',
    name: 'Pineapple - Musang King 3',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Musang King 3 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Musang King 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-d24-3',
    name: 'Banana - D24 3',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'D24 3 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['D24 3'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-d101-3',
    name: 'Avocado - D101 3',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'D101 3 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['D101 3'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-j-31-3',
    name: 'Guava - J-31 3',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'J-31 3 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['J-31 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-black-gold-3',
    name: 'Passion fruit - Black Gold 3',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Gold 3 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Black Gold 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-cheena-3',
    name: 'Dragon fruit - Cheena 3',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cheena 3 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Cheena 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-golden-pillow-3',
    name: 'Lychee - Golden Pillow 3',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden Pillow 3 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Golden Pillow 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-monthong-3',
    name: 'Rambutan - Monthong 3',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monthong 3 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Monthong 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-nangka-3',
    name: 'Durian - Nangka 3',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nangka 3 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Nangka 3'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-cempedak-3',
    name: 'Jackfruit - Cempedak 3',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cempedak 3 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Cempedak 3'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-honey-gold-3',
    name: 'Star fruit - Honey Gold 3',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Honey Gold 3 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Honey Gold 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-black-jack-3',
    name: 'Sapodilla - Black Jack 3',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Jack 3 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Black Jack 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-dang-rasimi-3',
    name: 'Mamey - Dang Rasimi 3',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dang Rasimi 3 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dang Rasimi 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-arkin-3',
    name: 'Mango - Arkin 3',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Arkin 3 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Arkin 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-fwang-tung-3',
    name: 'Papaya - Fwang Tung 3',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fwang Tung 3 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Fwang Tung 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-kari-3',
    name: 'Pineapple - Kari 3',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kari 3 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Kari 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-lara-3',
    name: 'Banana - Lara 3',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Lara 3 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Lara 3'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-sri-kembangan-3',
    name: 'Avocado - Sri Kembangan 3',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sri Kembangan 3 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Sri Kembangan 3'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-hasya-3',
    name: 'Guava - Hasya 3',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hasya 3 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Hasya 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-alano-3',
    name: 'Passion fruit - Alano 3',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alano 3 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Alano 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-morena-3',
    name: 'Dragon fruit - Morena 3',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Morena 3 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Morena 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-tikal-3',
    name: 'Lychee - Tikal 3',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tikal 3 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Tikal 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-prolific-3',
    name: 'Rambutan - Prolific 3',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prolific 3 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Prolific 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-magana-3',
    name: 'Durian - Magana 3',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Magana 3 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Magana 3'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-pace-3',
    name: 'Jackfruit - Pace 3',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pace 3 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Pace 3'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-pantin-3',
    name: 'Star fruit - Pantin 3',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pantin 3 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Pantin 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-mamey-3',
    name: 'Sapodilla - Mamey 3',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mamey 3 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Mamey 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-key-west-3',
    name: 'Mamey - Key West 3',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Key West 3 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Key West 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-atemoya-3',
    name: 'Mango - Atemoya 3',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Atemoya 3 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Atemoya 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-cherimoya-3',
    name: 'Papaya - Cherimoya 3',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cherimoya 3 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Cherimoya 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-sugar-apple-3',
    name: 'Pineapple - Sugar Apple 3',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sugar Apple 3 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Sugar Apple 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-custard-apple-3',
    name: 'Banana - Custard Apple 3',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Custard Apple 3 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Custard Apple 3'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-ilama-3',
    name: 'Avocado - Ilama 3',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ilama 3 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Ilama 3'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-soursop-3',
    name: 'Guava - Soursop 3',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Soursop 3 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Soursop 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-guanabana-3',
    name: 'Passion fruit - Guanabana 3',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Guanabana 3 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Guanabana 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-graviola-3',
    name: 'Dragon fruit - Graviola 3',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Graviola 3 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Graviola 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-biriba-3',
    name: 'Lychee - Biriba 3',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Biriba 3 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Biriba 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-wild-sugar-apple-3',
    name: 'Rambutan - Wild Sugar Apple 3',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wild Sugar Apple 3 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Wild Sugar Apple 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-rambutan-3',
    name: 'Durian - Rambutan 3',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rambutan 3 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Rambutan 3'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-pulasan-3',
    name: 'Jackfruit - Pulasan 3',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pulasan 3 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Pulasan 3'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-longan-3',
    name: 'Star fruit - Longan 3',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Longan 3 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Longan 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-dimocarpus-3',
    name: 'Sapodilla - Dimocarpus 3',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dimocarpus 3 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dimocarpus 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-kohala-3',
    name: 'Mamey - Kohala 3',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kohala 3 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Kohala 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-salak-3',
    name: 'Mango - Salak 3',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Salak 3 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Salak 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-snake-fruit-3',
    name: 'Papaya - Snake Fruit 3',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Snake Fruit 3 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Snake Fruit 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-mangosteen-3',
    name: 'Pineapple - Mangosteen 3',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mangosteen 3 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Mangosteen 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-queen-of-fruits-3',
    name: 'Banana - Queen of Fruits 3',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Queen of Fruits 3 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Queen of Fruits 3'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-purple-mangosteen-3',
    name: 'Avocado - Purple Mangosteen 3',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Mangosteen 3 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Purple Mangosteen 3'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-langsat-3',
    name: 'Guava - Langsat 3',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Langsat 3 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Langsat 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-duku-3',
    name: 'Passion fruit - Duku 3',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Duku 3 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Duku 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-longkong-3',
    name: 'Dragon fruit - Longkong 3',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Longkong 3 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Longkong 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-santol-3',
    name: 'Lychee - Santol 3',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Santol 3 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Santol 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-cotton-fruit-3',
    name: 'Rambutan - Cotton Fruit 3',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cotton Fruit 3 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Cotton Fruit 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-chico-3',
    name: 'Durian - Chico 3',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chico 3 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Chico 3'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-sapodilla-3',
    name: 'Jackfruit - Sapodilla 3',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sapodilla 3 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Sapodilla 3'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-naseberry-3',
    name: 'Star fruit - Naseberry 3',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Naseberry 3 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Naseberry 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-dilly-3',
    name: 'Sapodilla - Dilly 3',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dilly 3 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Dilly 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-sawo-3',
    name: 'Mamey - Sawo 3',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sawo 3 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Sawo 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-canistel-3',
    name: 'Mango - Canistel 3',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Canistel 3 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Canistel 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-egg-fruit-3',
    name: 'Papaya - Egg Fruit 3',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Egg Fruit 3 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Egg Fruit 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-yellow-sapote-3',
    name: 'Pineapple - Yellow Sapote 3',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow Sapote 3 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Yellow Sapote 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-black-sapote-3',
    name: 'Banana - Black Sapote 3',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Black Sapote 3 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Black Sapote 3'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-chocolate-pudding-fruit-3',
    name: 'Avocado - Chocolate Pudding Fruit 3',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chocolate Pudding Fruit 3 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Chocolate Pudding Fruit 3'],
    uses: ['fresh', 'guacamole', 'toast']
  },
  {
    id: 'guava-white-sapote-3',
    name: 'Guava - White Sapote 3',
    scientificName: 'Psidium guajava',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White Sapote 3 guava. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['White Sapote 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'passion-fruit-mexican-apple-3',
    name: 'Passion fruit - Mexican Apple 3',
    scientificName: 'Passiflora edulis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mexican Apple 3 passion fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Mexican Apple 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'dragon-fruit-casimiroa-3',
    name: 'Dragon fruit - Casimiroa 3',
    scientificName: 'Hylocereus undatus',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Casimiroa 3 dragon fruit. Stunning pink skin with white or red flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Casimiroa 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'lychee-green-sapote-3',
    name: 'Lychee - Green Sapote 3',
    scientificName: 'Litchi chinensis',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Sapote 3 lychee. Sweet translucent fruit in rough red skin.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Green Sapote 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'rambutan-matisia-3',
    name: 'Rambutan - Matisia 3',
    scientificName: 'Nephelium lappaceum',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Matisia 3 rambutan. Exotic tropical delicacy.',
    hardinessZones: '10-12',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Matisia 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'durian-jaboticaba-3',
    name: 'Durian - Jaboticaba 3',
    scientificName: 'Durio zibethinus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jaboticaba 3 durian. King of fruits, pungent aroma, custard flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Jaboticaba 3'],
    uses: ['fresh', 'desserts', 'ice cream']
  },
  {
    id: 'jackfruit-brazilian-grape-tree-3',
    name: 'Jackfruit - Brazilian Grape Tree 3',
    scientificName: 'Artocarpus heterophyllus',
    category: 'fruit',
    spacing: 360,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brazilian Grape Tree 3 jackfruit. Largest tree fruit, meaty texture when young.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '30-40 feet',
    family: 'Malvaceae',
    varieties: ['Brazilian Grape Tree 3'],
    uses: ['fresh', 'cooking', 'vegan meat']
  },
  {
    id: 'star-fruit-camu-camu-3',
    name: 'Star fruit - Camu Camu 3',
    scientificName: 'Averrhoa carambola',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Camu Camu 3 star fruit. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Camu Camu 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'sapodilla-myrciaria-3',
    name: 'Sapodilla - Myrciaria 3',
    scientificName: 'Manilkara zapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Myrciaria 3 sapodilla. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Myrciaria 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mamey-acerola-3',
    name: 'Mamey - Acerola 3',
    scientificName: 'Pouteria sapota',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Acerola 3 mamey. Exotic tropical delicacy.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Sapindaceae',
    varieties: ['Acerola 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'mango-barbados-cherry-3',
    name: 'Mango - Barbados Cherry 3',
    scientificName: 'Mangifera indica',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Barbados Cherry 3 mango. Sweet, juicy tropical fruit, national fruit of India.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Anacardiaceae',
    varieties: ['Barbados Cherry 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'papaya-malpighia-3',
    name: 'Papaya - Malpighia 3',
    scientificName: 'Carica papaya',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Malpighia 3 papaya. Fast-growing melon-like fruit with orange flesh.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '10-12 feet',
    spread: '6-8 feet',
    family: 'Caricaceae',
    varieties: ['Malpighia 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'pineapple-cupuacu-3',
    name: 'Pineapple - Cupuacu 3',
    scientificName: 'Ananas comosus',
    category: 'fruit',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 0,
    daysToHarvest: 540,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cupuacu 3 pineapple. Tropical favorite with spiky crown.',
    hardinessZones: '10-11',
    plantingSeason: 'spring',
    height: '15-30 feet',
    spread: '15-25 feet',
    family: 'Bromeliaceae',
    varieties: ['Cupuacu 3'],
    uses: ['fresh', 'smoothies', 'desserts']
  },
  {
    id: 'banana-theobroma-3',
    name: 'Banana - Theobroma 3',
    scientificName: 'Musa acuminata',
    category: 'fruit',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: ['papaya', 'pineapple'],
    enemies: [],
    description: 'Theobroma 3 banana. Starchy cooking or sweet dessert varieties.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '8-15 feet',
    spread: '6-8 feet',
    family: 'Musaceae',
    varieties: ['Theobroma 3'],
    uses: ['fresh', 'cooking', 'smoothies']
  },
  {
    id: 'avocado-bacuri-3',
    name: 'Avocado - Bacuri 3',
    scientificName: 'Persea americana',
    category: 'fruit',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bacuri 3 avocado. Creamy green fruit, perfect for guacamole.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-45 feet',
    spread: '25-35 feet',
    family: 'Lauraceae',
    varieties: ['Bacuri 3'],
    uses: ['fresh', 'guacamole', 'toast']
  }
]
